import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { FolderOpen } from 'lucide-react';
import { useThemeContext } from '../../../hook/useThemeManager';
import { theme } from '../../../constants/theme';

interface EmptyStateProps {
    title: string;
    message: string;
    icon?: React.ReactNode;
}

export function EmptyState({ title, message, icon }: EmptyStateProps) {
    const { themeStyle } = useThemeContext();
    const cardBg = theme[themeStyle].secondaryBg;
    const textColor = theme[themeStyle].tag_white;

    return (
        <Paper
            elevation={0}
            sx={{
                backgroundColor: cardBg,
                border: `1px solid ${theme[themeStyle].deep_grey}`,
                p: 4,
                textAlign: 'center',
            }}>
            <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
                {icon || <FolderOpen size={48} style={{ color: textColor, opacity: 0.6 }} />}
                <Typography variant="h6" fontWeight={600} sx={{ color: textColor }}>
                    {title}
                </Typography>
                <Typography variant="body2" sx={{ color: textColor, opacity: 0.8, maxWidth: 400 }}>
                    {message}
                </Typography>
            </Box>
        </Paper>
    );
}
